export enum ExperienceStatType {
	CCUS = 'ccus',
	RATING = 'rating',
	VISITS = 'visits',
	LIKES = 'likes',
	PLAYTIME = 'playtime',
	FAVORITES = 'favorites',
}
